import { Subscription } from 'rxjs';

import { Nullable } from '@assess/shared/type-utilities';

export const tryUnsubscribe = (subscription: Nullable<Subscription>): void => {
  if (!subscription) {
    return;
  }

  if (subscription.closed) {
    return;
  }

  subscription.unsubscribe();
};
